<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M5.026,12.988c-0.048,0-0.096-0.005-0.143-0.014c-0.242-0.047-0.447-0.211-0.546-0.439
		c-0.373-0.865-0.571-1.78-0.588-2.721C3.644,8.27,4.534,6.792,5.964,6.154c0.021-0.009,0.042-0.018,0.064-0.025
		c0.298-0.102,0.614-0.155,0.936-0.155c0.954,0,1.942,0.447,2.935,1.329c0.154,0.137,0.246,0.333,0.252,0.539
		c0.006,0.206-0.074,0.407-0.22,0.553l-4.374,4.374C5.417,12.907,5.224,12.988,5.026,12.988z M6.544,7.538
		C5.702,7.929,5.182,8.81,5.248,9.737c0,0.007,0.002,0.033,0.002,0.04c0.006,0.358,0.045,0.712,0.117,1.06l2.902-2.902
		C7.799,7.629,7.361,7.474,6.962,7.474C6.817,7.474,6.676,7.496,6.544,7.538z"/>
	<path d="M18.972,12.988c-0.2,0-0.389-0.078-0.531-0.22L14.069,8.39c-0.278-0.279-0.292-0.73-0.032-1.026
		c0.757-0.86,1.848-1.352,2.992-1.352c0.266,0,0.533,0.027,0.793,0.08c0.074,0.009,0.146,0.029,0.213,0.059
		c1.436,0.641,2.325,2.125,2.212,3.693c-0.014,0.91-0.212,1.822-0.586,2.69c-0.098,0.229-0.303,0.393-0.548,0.44
		C19.068,12.983,19.02,12.988,18.972,12.988z M18.633,10.836c0.072-0.347,0.111-0.701,0.117-1.058
		c0.067-0.94-0.433-1.818-1.247-2.22c-0.156-0.03-0.315-0.046-0.474-0.046c-0.474,0-0.935,0.135-1.331,0.386L18.633,10.836z"/>
	<path d="M11.999,21.791c-2.724-0.028-5.339-1.003-7.404-2.755l-0.112,0.112c-0.495,0.485-1.148,0.75-1.843,0.75
		c-0.693,0-1.345-0.264-1.835-0.744c-0.501-0.491-0.781-1.147-0.789-1.848c-0.008-0.701,0.258-1.363,0.749-1.865l0.537-0.537
		c-0.817-1.572-1.266-3.329-1.3-5.099c-0.107-3.169,1.813-6.07,4.78-7.214c0.698-0.24,1.413-0.359,2.14-0.359
		c1.739,0,3.488,0.671,5.077,1.943c1.589-1.274,3.34-1.945,5.081-1.945c0.722,0,1.432,0.118,2.112,0.35
		c2.988,1.152,4.914,4.058,4.807,7.235c-0.033,1.762-0.482,3.517-1.299,5.089l0.531,0.531c0.982,1.027,0.985,2.623,0.011,3.641
		c-0.499,0.522-1.173,0.809-1.897,0.809c0,0,0,0,0,0c-0.68,0-1.324-0.258-1.814-0.727l-0.124-0.124
		c-2.066,1.752-4.679,2.729-7.399,2.756c-0.001,0-0.003,0-0.004,0C12.002,21.791,12.001,21.791,11.999,21.791z M4.569,17.251
		c0.195,0,0.379,0.074,0.52,0.209c1.869,1.798,4.325,2.803,6.918,2.83c2.582-0.026,5.037-1.031,6.905-2.83
		c0.14-0.135,0.325-0.21,0.52-0.21c0.2,0,0.389,0.078,0.531,0.22l0.616,0.616c0.201,0.192,0.474,0.301,0.763,0.301
		c0.312,0,0.601-0.123,0.815-0.347c0.417-0.436,0.417-1.119,0-1.555l-0.918-0.918c-0.241-0.241-0.289-0.615-0.116-0.909
		c0.868-1.479,1.344-3.166,1.376-4.88c0.086-2.548-1.449-4.871-3.82-5.786c-0.518-0.177-1.07-0.269-1.628-0.269
		c-1.53,0-3.104,0.69-4.55,1.996c-0.138,0.125-0.317,0.193-0.503,0.193s-0.365-0.069-0.502-0.193
		C10.051,4.413,8.48,3.723,6.952,3.723c-0.562,0-1.119,0.093-1.656,0.278c-2.35,0.907-3.88,3.226-3.794,5.765
		c0.033,1.723,0.509,3.412,1.376,4.891c0.173,0.294,0.125,0.668-0.117,0.91l-0.93,0.93c-0.206,0.21-0.319,0.493-0.315,0.793
		c0.003,0.301,0.123,0.582,0.338,0.792c0.209,0.205,0.489,0.317,0.787,0.317c0.298,0,0.578-0.113,0.787-0.318l0.61-0.61
		C4.18,17.33,4.369,17.251,4.569,17.251z"/>
	<path d="M11.999,18.041C10.017,18,8.144,17.234,6.712,15.885c-0.147-0.138-0.233-0.333-0.236-0.534
		c-0.003-0.202,0.077-0.4,0.22-0.542l4.773-4.771c0.142-0.142,0.33-0.219,0.53-0.219c0.2,0,0.389,0.078,0.53,0.219l4.773,4.772
		c0.142,0.142,0.223,0.339,0.22,0.541s-0.089,0.397-0.236,0.535c-1.433,1.349-3.305,2.114-5.271,2.155c-0.003,0-0.005,0-0.008,0
		H11.999z M8.336,15.29c1.061,0.78,2.349,1.221,3.671,1.25c1.307-0.029,2.594-0.47,3.655-1.25l-3.663-3.662L8.336,15.29z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'fast-food-pretzel',
    },
    name: {
      type: String,
      required: false,
      default: 'FastFoodPretzel',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>